import { computed, inject, Injectable } from '@angular/core';
import { OrderSelectedCustomization } from '../../../../../../models/order/api-models/order-pd-response.model';
import { OrderStateServiceV2 } from '../../order-state.service';
import { OrderFlowType } from '../../../../../../models/order/order.model';
import { InternetProductResponseService } from '../../order-api-response/internet-pd-response.service';
import { OrderCustomizationSubPayload } from '../../../../../../models/order/workflow/order-customization.model';
import { EarthlinkInternetCustomizationStateService } from './oof-customization-state-service/earthlink-internet-customization.state.service';

@Injectable({ providedIn: 'root' })
export class OrderInternetCustomizationsStateService {
    private orderStateService = inject(OrderStateServiceV2);
    private internetPdResponseService = inject(InternetProductResponseService);
    private earthlinkInternetCustomizationStateService = inject(EarthlinkInternetCustomizationStateService);

    selectedCustomizations = computed(() => {
        const order = this.orderStateService.order();
        const internetPdResponse = this.internetPdResponseService.productResponse();
        if (!order || !internetPdResponse) return [];

        const selectedOffers = order.internetFlow?.internetOffers?.offers || [];
        if (!selectedOffers.length) return [];

        const result: OrderSelectedCustomization[] = [];
        for (const offer of selectedOffers) {
            // Prefer the exact customization: New/Port voice variants share choiceCodes
            // with different fees, so choiceCode alone resolves to the wrong one.
            const byCode = offer.customizationCode
                ? this.internetPdResponseService.findByCustomizationCode(offer.customizationCode)
                : undefined;
            const customization = byCode?.customization.Choices?.Choice?.some(c => c.ChoiceCode === offer.choiceCode)
                ? byCode
                : this.internetPdResponseService.findCustomizationByChoiceCode(offer.choiceCode);
            if (customization) {
                const choice = customization.customization.Choices?.Choice
                    .find(c => c.ChoiceCode === offer.choiceCode);
                result.push({
                    type: OrderFlowType.Internet,
                    choice,
                    customizationReference: customization,
                    customization: customization.customization
                });
            }
        }
        result.sort((a, b) => (a.choice?.CartSeq || 0) - (b.choice?.CartSeq || 0));
        return result;
    });

    buildCustomizationPayload(): OrderCustomizationSubPayload[] {

        if (this.orderStateService.isOOFEarthlinkProvider()) {
            return this.earthlinkInternetCustomizationStateService.buildCustomizationPayload(this.selectedCustomizations());
        }
        const updateComponent = this.internetPdResponseService.getUpdateOfferProductComponent();
        const originalComponent = this.internetPdResponseService.getProductComponent();
        const internetComponent = updateComponent ?? originalComponent;
        if (!internetComponent) return null;

        if (internetComponent) {
            const customizations = [];
            internetComponent.Customizations?.Customization.forEach(cust => {
                if (cust.Choices?.Choice?.length) {
                    cust.Choices?.Choice.forEach(choice => {
                        const rootPayload: OrderCustomizationSubPayload = {
                            Choice: choice.ChoiceCode || '',
                            Code: cust.CustomizationCode || '',
                            Customizations: [],
                            Usoc: choice.Usoc || ''
                        };

                        if (choice.Customizations?.Customization?.length) {
                            choice.Customizations?.Customization.forEach(nestedCust => {
                                if (nestedCust.Choices?.Choice?.length) {
                                    nestedCust.Choices?.Choice.forEach(nestedChoice => {
                                        const isSelected = this.selectedCustomizations().filter(x => x.type === OrderFlowType.Internet).find(selCust => selCust.choice?.ChoiceCode === nestedChoice.ChoiceCode);
                                        if (isSelected) {
                                            rootPayload.Customizations.push({
                                                Choice: isSelected.choice?.ChoiceCode || '',
                                                Code: isSelected.customization?.CustomizationCode || '',
                                                Usoc: isSelected.choice?.Usoc || '',
                                            });
                                        }
                                    });
                                }
                            });
                        }
                        customizations.push(rootPayload);
                    });
                }
            })

            return customizations.length > 0 ? customizations : null;
        }

        return null;
    }
}


